import headerTop from "@/components/HeaderTop";
import {
  deepCopy
} from "@/utils/deepCopy";
import {
  areaSearchAllTree,
  areaSearch
} from "@/http/api/area";
import {
  debounce
} from "@/utils/debounce";
import {
  dateFormat,
  getEnumLabelOptions,
  getEnumOptions
} from "@/common/filters";
import {
  getCustomers,
  deleteCustomer,
  deleteCustomers
} from "@/http/api/customer";
import {customerSettings} from "@/http/api/system";
import {getEnumMetaNameData} from "@/utils/getEnumMeta";

export default {
  components: {
    headerTop,
  },
  data() {
    return {
      filterDate: "",
      search: '前缀搜索',
      searchKey: "",
      searchValue: "",
      searchText: "请输入客户名称/联系方式/经纪人",
      pageIndex: 1,
      totalCount: 0,
      isDelete: false,
      isLoading: null,
      filterInitData:{},
      price: {
        min: '',
        max: ''
      },
      query: {
        filter: '',
        condition: '',
        intention: '',
        city: '',
        district: '',
        minTotalPrice: '',
        maxTotalPrice: '',
        houseType: [],
        followLevel: '',
        startTime: '',
        endTime: '',
        sourceType: '',
        visitStatus: '',
        sorting: 'creationTime desc',
        skipCount: '',
        maxResultCount: 20
      },
      filterTags: [],
      filterData: {
        position: [],
        district: [],
        intention: [],
        price: [{
            label: "不限",
            value: "",
            isSelected: true,
          },
          {
            label: "50万以下",
            value: "50万以下",
            isSelected: false,
          },
          {
            label: "50-80万",
            value: "50-80万",
            isSelected: false,
          },
          {
            label: "80-120万",
            value: "80-120万",
            isSelected: false,
          },
          {
            label: "120-160万",
            value: "120-160万",
            isSelected: false,
          },
          {
            label: "160-200万",
            value: "160-200万",
            isSelected: false,
          },
          {
            value: "200-250万",
            label: "200-250万",
            isSelected: false,
          },
          {
            label: "250-300万",
            value: "250-300万",
            isSelected: false,
          },
          {
            label: "300-400万",
            value: "300-400万",
            isSelected: false,
          },
          {
            label: "400-500万",
            value: "400-500万",
            isSelected: false,
          },
          {
            label: "500万以上",
            value: "500万以上",
            isSelected: false,
          },
        ],
        houseType: [],
        followLevel: [],
        filter: [{
            name: "录入时间",
            label: "creationTime",
            children: [
              {
                name: "自定义"
              },
              {
                name: "不限"
              },
              {
                name: "今日"
              },
              {
                name: "3日内"
              },
              {
                name: "7日内"
              },
              {
                name: "15日内"
              },
            ],
          },
          {
            name: "来源",
            label: 'sourceType',
            children: [],
          },
          {
            name: "带看进度",
            label: 'visitStatus',
            children: [],
          },
        ],
      },
      //权限
      permissions: {},
      customers: [],
      multipleSelection: [],
      searchOptions: [{
          value: "name",
          label: "客户名称",
        },
        {
          value: "phoneNumber",
          label: "联系方式",
        },
        {
          value: "creatorName",
          label: "经纪人",
        },
        {
          value: "",
          label: "全文搜索",
        },
      ],

    };
  },
  filters: {
    addressesFilter(v) {
      let arr = [];
      let str='';
      v.map(el => {
        arr.push(el.business);
      })
      if (arr.length) {
        str=arr.join('，');
      } else {
        str='—'
      }
      return str?str:'—'
    }
  },
  methods: {
    // 基础配置项初始化
    initSettings() {
      this.filterData.filter.map(el => {
        if (el.label == 'visitStatus') {
          el.children = getEnumMetaNameData(this.$store.getters.enumMetadata, 'CustomerVisitStatus');
          el.children.unshift({
            name: "不限",
            value: "",
          })
        }
      })
      customerSettings().then((res) => {
        let data = res.result;
        this.filterData.intention = getEnumLabelOptions(data, "Deer.Customer.Collection.IntentionType");
        this.filterData.intention.unshift({
          label: "不限",
          value: "",
          isSelected: true,
        })
        this.filterData.houseType = getEnumLabelOptions(data, "Deer.Customer.Collection.HouseType");
        this.filterData.houseType.unshift({
          label: "不限",
          value: "",
          isSelected: true,
        })
        this.filterData.followLevel = getEnumLabelOptions(data, "Deer.Customer.Collection.AttentionLevelType");
        this.filterData.followLevel.unshift({
          label: "不限",
          value: "",
          isSelected: true,
        })
        this.filterData.followLevel = getEnumLabelOptions(data, "Deer.Customer.Collection.AttentionLevelType");
        this.filterData.followLevel.unshift({
          label: "不限",
          value: "",
          isSelected: true,
        })
        this.filterData.filter.map(el => {
          if (el.label == 'sourceType') {
            el.children = getEnumOptions(res.result, "Deer.Customer.Collection.SourceType");
            el.children.unshift({
              name: "不限",
              value: "",
            })
          }
        })
        this.areaSearchAllTree();
      });
    },
    areaSearchAllTree() {
      areaSearchAllTree().then((res) => {
        let arr = [];
        res.result.items.map((item) => {
          if (item.data.status) {
            arr.push(item);
          }
        });
        arr.map((el) => {
          el.data.isSelected = false;
          if (el.children.length) {
            el.children.map((item) => {
              item.data.isSelected = false;
            });
          }
        });
        arr.unshift({
          data: {
            name: "不限",
            isSelected: true
          },
          children: [],
        });
        this.areas = deepCopy(arr);
        this.filterData.position = arr;
        this.filterInitData=deepCopy(this.filterData);
      });
    },
    searchCustomers() {
      if (this.searchValue) {
        this.getCustomers()
      }
    },
    // 排序
    changeSort(val) {
      this.query.sorting =
        val.order == "descending" ?
        `${val.prop} desc` :
        val.order == "ascending" ?
        `${val.prop} asc` :
        "";
      this.getCustomers();
    },
    // 选择搜索项
    selectItem(arr, label, value, name, key, children) {
      arr.map((el) => {
        if (el.label == label) {
          el.isSelected = true;
        } else {
          el.isSelected = false;
        }
      });
      if (name == "位置") {
        //console.log(arr, label, value, name, key, children, "获取的地区信息");
        arr.map((el) => {
          if (el.data.name == label) {
            el.data.isSelected = true;
          } else {
            el.data.isSelected = false;
          }
        });
        this.filterData.district = []
        //console.log(this.filterData.district, 123123, children);
        this.filterData.district = deepCopy(children);
        if (children.length > 0) {
          this.filterData.district.unshift({
            data: {
              name: "不限",
              isSelected: true
            },
            children: [],
          });
        }
      } else if (name == "区县") {
        arr.map((el) => {
          if (el.data.name == label) {
            el.data.isSelected = true;
          } else {
            el.data.isSelected = false;
          }
        });
      }
      if (label == '自定义价格') {
        let v = this.price.min + '-' + this.price.max + '万';
        this.filterTagsPush(name, v, v, key);
      } else if (name == '价格') {
        this.price = {
          min: '',
          max: '',
        }
        this.filterTagsPush(name, label, value, key);
      } else {
        this.filterTagsPush(name, label, value, key);
      }
    },
    // 搜索前置条件
    filterSelect(val) {
      switch (val) {
        case "name":
          this.searchText = "请输入客户名称";
          break;
        case "phone":
          this.searchText = "请输入联系方式";
          break;
        case "creatorName":
          this.searchText = "请输入经纪人";
          break;
        case "":
          this.searchText = "请输入客户名称/联系方式/经纪人";
          break;
      }
      this.searchKey = val;
      //console.log(this.searchKey, 'this.searchKey');
    },
    // 跳转添加客源页
    createCustomer() {
      if (this.permissions["Customer.Create"]) {
        this.$router.push({
          name: "customerCreate"
        });
      } else {
        this.$message.warning({
          message: "您暂无创建客户权限",
          showClose: true,
        });
      }
    },
    // 获取客源
    getCustomers() {
      let query = {
        maxResultCount: this.query.maxResultCount,
        skipCount: (this.pageIndex - 1) * this.query.maxResultCount,
      };
      if (this.searchValue) {
        query.filter = this.searchValue;
        if (this.searchKey) {
          query.condition = this.searchKey;
        }
      }
      if (this.query.intention) {
        query.intention = this.query.intention;
        //console.log(query, 'queryqueryquery');
      }
      if (this.query.city) {
        query.city = this.query.city=="不限"?"":this.query.city;
      }
      if (this.query.district) {
        query.district = this.query.district;
      }
      if (this.query.minTotalPrice) {
        query.minTotalPrice = this.query.minTotalPrice;
      }
      if (this.query.maxTotalPrice) {
        query.maxTotalPrice = this.query.maxTotalPrice;
      }
      if (this.query.houseType) {
        query.houseType = this.query.houseType;
      }
      if (this.query.followLevel) {
        query.followLevel = this.query.followLevel;
      }
      if (this.query.startTime) {
        query.startTime = dateFormat(this.query.startTime);
        query.endTime = dateFormat(this.query.endTime);
        query.timeCondition = 'creationTime';
      }
      if (this.query.sourceType) {
        query.sourceType = this.query.sourceType;
      }
      if (this.query.visitStatus) {
        query.visitStatus = this.query.visitStatus;
      }
      if (this.query.sorting) {
        query.sorting = this.query.sorting;
      }
      this.isLoading = true;
      if (!this.isDelete) {
        this.customers = [];
      }
      this.isDelete = false;
      getCustomers(query).then(res => {
        this.customers = res.result.items;
        this.totalCount = res.result.totalCount;
        this.isLoading = false;
      })
    },
    // 筛选项时间自定义回调
    changeFilterDate(v, name) {
      let value = v.join("~");
      this.filterTagsPush(name, value, v);
    },
    // 选择位置
    selectPostion(arr, v, name) {
      arr.map((el) => {
        if (el.value == v) {
          el.isSelected = true;
        } else {
          el.isSelected = false;
        }
      });
      this.filterTagsPush(name, v);
    },
    // 清空搜索条件
    clearTags() {
      this.filterTags = [];
      this.filterData=deepCopy(this.filterInitData);
      Object.assign(this.$data.query, this.$options.data().query);
      this.searchKey = "";
      this.searchText = "请输入客户名称/联系方式/经纪人";
      this.search = "前缀搜索";
      this.searchValue = "";
      this.price = {
        min: '',
        max: ''
      };
      this.getCustomers();
    },
    // 筛选条件添加
    filterTagsPush(name, label, value, key) {
      //console.log(name, label, value, key, 'name, label, value, key');
      if (label != "自定义") {
        let obj = {
          name,
          label
        };
        let item = this.filterTags.find((el) => {
          return el.name == name;
        });
        if (item) {
          this.filterTags.map((el) => {
            if (el.name == name) {
              if (label) {
                if (label == "不限") {
                  this.filterTags.splice(this.filterTags.indexOf(el), 1);
                } else {
                  el.label = label;
                }
              } else {
                this.filterTags.splice(this.filterTags.indexOf(el), 1);
              }
            }
          });
        } else {
          if (label && label != "不限") {
            this.filterTags.push(obj);
          }
        }
      }
      if (name == "区县") {
        if (label != "不限") {
          let tagIndex = 0;
          this.filterTags.map((item, index) => {
            if (item.name == "位置") {
              if (item.label.indexOf("-") != -1) {
                item.label = item.label.split("-")[0] + "-" + label;
              } else {
                item.label = item.label + "-" + label;
              }
            }
            if (item.name == "区县") {
              tagIndex = index;
            }
          });
          this.filterTags.splice(tagIndex, 1);
        } else {
          this.filterTags.map((item, index) => {
            if (item.name == "位置") {
              item.label = item.label.split("-")[0];
            }
          });
        }
      }
      if (name == "位置") {
        this.query.city = label;
      } else if (name == "区县") {
        //console.log(name, label, 123123123123);
        this.query.district = (label !== '不限' ? label : '');
      } else if (name == "录入时间") {
        if (label == "今日") {
          this.query.startTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime()
          );
          this.query.endTime = new Date();
        } else if (label == "3日内") {
          this.query.startTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 3
          );
          this.query.endTime = new Date();
        } else if (label == "7日内") {
          this.query.startTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7
          );
          this.query.endTime = new Date();
        } else if (label == "15日内") {
          this.query.startTime = new Date(
            new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 15
          );
          this.query.endTime = new Date();
        } else if (label == "不限") {
          this.query.startTime = "";
          this.query.endTime = "";
        } else {
          this.query.startTime = value[0];
          this.query.endTime = value[1];
        }
      } else if (name == '价格') {
        let arr = value.split('-');
        if (arr.length > 1) {
          this.query.minTotalPrice = parseInt(arr[0]);
          this.query.maxTotalPrice = parseInt(arr[1]);
        } else {
          let priceArr = arr[0].split('万以');
          if (priceArr[1] == '下') {
            this.query.maxTotalPrice = priceArr[0];
          } else {
            this.query.minTotalPrice = priceArr[0];
          }
        }
      } else {
        this.query[key] = value;
      }
      this.getCustomers();
    },
    // 移除筛选标签
    handleTagClose(tag) {
      //console.log(tag, 'tag');
      this.filterTags.splice(this.filterTags.indexOf(tag), 1);
      switch (tag.name) {
        case "位置":
          this.query.city = "";
          this.query.district = "";
          this.$nextTick(() => {
            this.filterData.position = this.areas;
            this.filterData.district = [];
          });
          break;
        case "意图":
          this.filterDateInit("intention");
          this.query.intention = '';
          break;
        case "价格":
          this.filterDateInit("price");
          this.price = {
            min: "",
            max: ""
          };
          this.query.minTotalPrice = '';
          this.query.maxTotalPrice = '';
          break;
        case "面积":
          this.filterDateInit("area");
          this.query.area = {
            min: "",
            max: ""
          };
          break;
        case "居室":
          this.filterDateInit("houseType");
          this.query.houseType = '';
          break;
        case "等级":
          this.filterDateInit("followLevel");
          this.query.followLevel = '';
          break;
        case "来源":
          this.query.sourceType = '';
          break;
        case "录入时间":
          this.query.startTime = '';
          break;
        case "带看进度":
          this.query.visitStatus = '';
          break;
      }
      this.getCustomers();
    },
    // 筛选项isSelected初始化
    filterDateInit(v) {
      this.filterData[v].map((el) => {
        if (el.label == "不限") {
          el.isSelected = true;
        } else {
          el.isSelected = false;
        }
      });
    },
    // 跳转客源详情
    goCustomerDetail(id) {
      this.$router.push("/customer/detail/" + id);
    },
    // 编辑客源
    editCustomer(id) {
      if (this.permissions['Customer.Update']) {
        this.$router.push("/customer/update/" + id);
      } else {
        this.$message.warning({
          message: "您暂无管理客户权限",
          showClose: true,
        });
      }
    },
    // 删除客源
    delCustomer(id) {
      if (this.permissions['Customer.Delete']) {
        this.$confirm(
            `确定删除此客户？删除后客户将不存在，请谨操作！`,
            "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
          .then(() => {
            deleteCustomer(id).then((res) => {
              this.isDelete = true;
              this.getCustomers();
              if (res) {
                this.$message.success({
                  message: "删除成功",
                  showClose: true
                });
              }              
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无删除客户权限",
          showClose: true,
        });
      }
    },
    // 批量删除客源
    deleteCustomers() {
      if (this.permissions['Customer.Delete']) {
        this.$confirm(`删除后客户将不存在，请谨慎操作！`, "温馨提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
          .then(() => {
            let arr = [];
            this.multipleSelection.map((el) => {
              arr.push("customerIds=" + el);
            });
            arr = arr.join("&");
            deleteCustomers(arr).then((res) => {
              this.isDelete = true;
              this.getCustomers();
              if (res) {
                this.$message.success({
                  message: "删除成功",
                  showClose: true
                });
              }
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      } else {
        this.$message.warning({
          message: "您暂无删除客户权限",
          showClose: true,
        });
      }

    },
    // 多选框回调
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.map((el) => {
        this.multipleSelection.push(el.id);
      });
    },
    // 更改的页面数量
    handleSizeChange(val) {
      this.query.maxResultCount = val;
      this.getCustomers();
    },
    // 跳转的指定页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getCustomers();
    },
    // 筛选项下拉菜单的子菜单回调
    dropdownChildClick(v) {
      let name = v.split(" ")[0];
      let value = v.split(" ")[1];
      this.filterTagsPush(name, value);
      this.$refs[name][0].hide();
    },
    // 筛选项下拉菜单回调
    dropdownClick(command) {
      let name = command.split(" ")[0];
      let label = command.split(" ")[1];
      let value = command.split(" ")[2];
      let key = command.split(" ")[3];
      if (label != "自定义") {
        this.filterTagsPush(name, label, value, key);
      }
    },
    init() {
      this.permissions = this.$store.getters.permissions;
      this.$watch(
        "searchValue",
        debounce((val) => {
          this.getCustomers();
        }, 200)
      );
      this.getCustomers();
      this.initSettings();
      //console.log(666);
    }
  },
  mounted() {
    this.init();
  },
};